/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesDataCentersDcIdPng } from "../../funcs/imagesGetApiV3ImagesDataCentersDcIdPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ImagesDataCentersDcIdPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesDataCentersDcIdPng: ToolDefinition<
  typeof args
> = {
  name: "images-get-api-v3-images-data-centers-dc-id-png",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetApiV3ImagesDataCentersDcIdPng(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
